var map = {
	"./aboutus.png": 641,
	"./accessories.png": 642,
	"./appstore.png": 643,
	"./arrow.png": 644,
	"./arrow1.png": 645,
	"./arrow2.png": 646,
	"./arrow3.png": 647,
	"./banner.png": 648,
	"./banner_v1.png": 649,
	"./bullet-footer.png": 650,
	"./calc_left.png": 651,
	"./calc_right.png": 652,
	"./chart.png": 653,
	"./collections.png": 654,
	"./de.png": 533,
	"./download_back.png": 655,
	"./dynamic.png": 656,
	"./easy.png": 657,
	"./en.png": 534,
	"./enprimeur.png": 658,
	"./es.png": 659,
	"./fr.png": 535,
	"./googleplay.png": 660,
	"./home-gift.png": 661,
	"./home_banner.png": 662,
	"./home_chart.png": 663,
	"./home_chart_de.png": 664,
	"./home_chart_fr.png": 665,
	"./home_chart_it.png": 666,
	"./home_chart_ru.png": 667,
	"./home_collections_de.png": 668,
	"./home_collections_en.png": 669,
	"./home_collections_fr.png": 670,
	"./home_collections_it.png": 671,
	"./home_collections_ru.png": 672,
	"./home_en_primeur.png": 673,
	"./home_en_primeur_de.png": 674,
	"./home_en_primeur_fr.png": 675,
	"./home_en_primeur_it.png": 676,
	"./home_live_market.png": 677,
	"./home_logo.png": 678,
	"./home_logo2.png": 679,
	"./home_logo_footer.png": 680,
	"./home_pie_chart.png": 681,
	"./home_pie_chart_de.png": 682,
	"./home_pie_chart_fr.png": 683,
	"./home_pie_chart_it.png": 684,
	"./home_testimonial1.png": 685,
	"./home_testimonial2.png": 686,
	"./home_testimonial3.png": 687,
	"./icon.png": 688,
	"./instagram.png": 689,
	"./iphone.png": 690,
	"./it.png": 536,
	"./live.png": 691,
	"./lock.png": 692,
	"./mail.png": 693,
	"./main_home1.png": 694,
	"./main_home2.png": 695,
	"./main_home3.png": 696,
	"./main_home4.png": 697,
	"./main_home_phone.png": 698,
	"./main_home_phone_de.png": 699,
	"./main_home_phone_fr.png": 700,
	"./main_home_phone_it.png": 701,
	"./main_home_phone_ru.png": 702,
	"./play_btn.png": 703,
	"./price.png": 704,
	"./ru.png": 537,
	"./scroll.png": 705,
	"./section10_de.png": 706,
	"./section10_en.png": 707,
	"./section10_fr.png": 708,
	"./section10_it.png": 709,
	"./section10_ru.png": 710,
	"./secure.png": 711,
	"./send.png": 712,
	"./social.png": 713,
	"./star.png": 714,
	"./start-investing.png": 715,
	"./sv.png": 716,
	"./testimonial.png": 717,
	"./testimonials_left.png": 718,
	"./testimonials_right.png": 719,
	"./text_page_banner.png": 720,
	"./tweeter.png": 721,
	"./wine-drop-red.png": 722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 640;